import { useSetRecoilState } from "recoil";
import WxContentsDispatcher from "./WxContentsDispatcher";
import { amedasElementState } from "../../../store/AmedasElementState";

const AmedasDispatcher = (props) => {
  const setAmedasElementInfo = useSetRecoilState(amedasElementState);

  props.contents.setAmedasElementInfoDispatcher((typeInfo) => {
    setAmedasElementInfo(typeInfo);
  });

  return <WxContentsDispatcher {...props}/>
};

export default AmedasDispatcher;
